//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.OrdinateBaselineBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../no/SelectNXObjectList.js";
import "../Annotations/Annotations.TableStyleBuilder.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Baseline",0,"Annotations.OrdinateBaselineBuilder",0],[1,"Inherit",0,"SelectDisplayableObject",0],[1,"OrdinateOrigin",0,"SelectDisplayableObject",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"SelectedObjects",0,"SelectNXObjectList",0],[1,"Style",0,"Annotations.TableStyleBuilder",0]],[[[],"ResetHoletableOrdinateOrigin",{},0,0],[[],"ResetLabelPosition",{},0,0]],[]];
SPLM.Annotations.HoleTableBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.HoleTableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;